

























































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';

@Component
export default class UploadIntegrationData extends Mixins(InputFieldMethods, NotifyMethods) {
    public newIntegrationFileName: string = '';
    public newIntegrationFile: any = '';

    constructor() {
        super();
    }

    get uploadingStatus() {
        return this.$store.getters['Integrations/getIntegrationUploadingStatus'];
    }

    get uploadingPercentage() {
        return this.$store.getters['Integrations/getIntegrationUploadingPercentage'];
    }

    get corporationId() {
        return this.$store.getters['User/getCorporationId'];
    }

    public selectFileToUpload(event: any) {
        const element = (event.target as HTMLInputElement);

        if (element.files.length === 0) {
            return;
        }

        const filename = element.files[0].name;

        this.newIntegrationFileName = filename.split(/\.(?=[^\.]+$)/)[0];
        this.newIntegrationFile = (element.files[0] as File);

        element.type = 'text';
        element.type = 'file';
    }

    public uploadIntegrationData() {
        if (this.newIntegrationFileName === '' || this.newIntegrationFile === '') {
            return this.notify('please_attach_first', 'warning');
        }

        this.$store.dispatch(Actions.UPLOAD_INTEGRATION_DATA, {
            file: this.newIntegrationFile,
        });
    }

    public cancel() {
        this.$store.commit(Mutations.SET_ADD_INTEGRATION_VISIBILITY, false);
    }

    public created() {
        this.newIntegrationFileName = '';
        this.newIntegrationFile = '';
    }
}
